var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Dividir en lotes")]),_vm._l((_vm.splitCoverages),function(sc,i){return _c('div',{key:i,staticClass:"d-flex p-2"},[_c('fg-input',{attrs:{"type":"number","min":"0","label":sc.description},model:{value:(sc.splitValue),callback:function ($$v) {_vm.$set(sc, "splitValue", $$v)},expression:"sc.splitValue"}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }